// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QrCode_wrapper__6qnOa","overlay":"QrCode_overlay__f06ZH","errorMessage":"QrCode_errorMessage__kmXqH","warningIcon":"QrCode_warningIcon__Bm77G"};